import Box from '@mui/material/Box';
import {
  DatePicker as MuiDatePicker,
  type DatePickerProps as MuiDatePickerProps,
} from '@mui/x-date-pickers/DatePicker';

import { InfoIconButton } from '../InfoIconButton';

export type DatePickerProps = {
  infoTooltip?: string;
  fullWidth?: boolean;
} & MuiDatePickerProps;

export const DatePicker = ({ infoTooltip, fullWidth = false, format = 'DD/MM/YYYY', ...rest }: DatePickerProps) => {
  return infoTooltip ? (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
      }}
    >
      <MuiDatePicker format={format} {...rest} sx={{ width: fullWidth ? '100%' : undefined }} />
      <InfoIconButton tooltip={infoTooltip} sx={{ marginTop: 1 }} />
    </Box>
  ) : (
    <MuiDatePicker format={format} {...rest} />
  );
};
